import request from '@/utils/request'


// 查询病种信息列表
export function listDisease(query) {
  return request({
    url: '/disease/disease/list',
    method: 'get',
    params: query
  })
}

// 查询病种信息分页
export function pageDisease(query) {
  return request({
    url: '/disease/disease/page',
    method: 'get',
    params: query
  })
}

// 查询病种信息详细
export function getDisease(data) {
  return request({
    url: '/disease/disease/detail',
    method: 'get',
    params: data
  })
}

// 新增病种信息
export function addDisease(data) {
  return request({
    url: '/disease/disease/add',
    method: 'post',
    data: data
  })
}

// 修改病种信息
export function updateDisease(data) {
  return request({
    url: '/disease/disease/edit',
    method: 'post',
    data: data
  })
}

// 删除病种信息
export function delDisease(data) {
  return request({
    url: '/disease/disease/delete',
    method: 'post',
    data: data
  })
}


export function importDisease(data) {
  return request({
    url: '/disease/disease/import',
    method: 'post',
    data: data
  })
}